import { initClient, initClientNavigation } from 'rwsdk/client';

const { handleResponse, onHydrated } = initClientNavigation();
initClient({ handleResponse, onHydrated });
